import {useHistory} from "react-router";
import {Col, Row} from "react-bootstrap";
import globalStyle from '@/styles/Global.scss';

const CandMInformation = ({attributes = []}) => {
  const history = useHistory()

  const linkTo = (url, description) => {
    return <span className={globalStyle.link} onClick={() => window.open(url, '_blank')}>{description}</span>
  }

  return (
    <>
      <hr/>
      <Row>
        <Col xs={2}></Col>
        <Col xs={8}>{linkTo('https://cardandmedia.co.jp/aboutus.html', '企業情報')}</Col>
        <Col xs={2}></Col>

        <Col xs={2}></Col>
        <Col xs={4}><span className={globalStyle.link} onClick={() => history.push('/about')}>名刺Rについて</span></Col>
        <Col xs={4}><span className={globalStyle.link} onClick={() => history.push('/uses')}>サイトのご利用について</span></Col>
        <Col xs={2}></Col>

        <Col xs={2}></Col>
        <Col xs={4}>{linkTo('https://cardandmedia.co.jp/privacy.html', 'プライバシーポリシー')}</Col>
        <Col xs={4}><span className={globalStyle.link} onClick={() => history.push('/restriction')}>利用規約</span></Col>
        <Col xs={2}></Col>

        <Col xs={2}></Col>
        <Col xs={4}>よくある質問</Col>
        <Col xs={4}></Col>
        <Col xs={2}></Col>

        <Col xs={2}></Col>
        <Col xs={8}><span style={{fontSize: '0.7em'}}>@Copyright(C) 2023 Card&Media Inc. All right reserved.</span></Col>
        <Col xs={2}></Col>
      </Row>

      <div style={{ display: 'flex', justifyContent: 'center', width: '100%', marginTop: '20px', padding: '20px 0 20px 0', borderTop: '1px black solid', backgroundColor: 'lightgray'}}>
        <img alt={'logo'} src={'/candm_s.png'}/>
      </div>
    </>
  )
}

export default CandMInformation;
